import deputyReducer from "./deputyReducer";

const deputyReducers = {
    deputy: deputyReducer,
}

export default deputyReducers;